module.exports = __webpack_public_path__ + "img/bg-blue.b5e73884.png";